const HeroSection = {
  hero_title_part1: "hero_title_part1",
  hero_title_part2: "hero_title_part2",
  hero_text: "hero_text",
  hero_btn: "hero_btn",
  hero_card_title: "hero_card_title",
  hero_card_section_title1: "hero_card_section_title1",
  hero_card_section_text1: "hero_card_section_text1",
  hero_card_section_title2: "hero_card_section_title2",
  hero_card_section_text2: "hero_card_section_text2",
  hero_card_section_title3: "hero_card_section_title3",
  hero_card_section_text3: "hero_card_section_text3",
  hero_card_btn: "hero_card_btn",
  hero_presentation_title1: "hero_presentation_title1",
  hero_presentation_text1: "hero_presentation_text1",
  hero_presentation_content1_title1: "hero_presentation_content1_title1",
  hero_presentation_content1_text1: "hero_presentation_content1_text1",
  hero_presentation_content1_title2: "hero_presentation_content1_title2",
  hero_presentation_content1_text2: "hero_presentation_content1_text2",
  hero_presentation_content1_title3: "hero_presentation_content1_title3",
  hero_presentation_content1_text3: "hero_presentation_content1_text3",
  hero_presentation_title2: "hero_presentation_title2",
  hero_presentation_text2: "hero_presentation_text2",
  hero_presentation_content2_title1: "hero_presentation_content2_title1",
  hero_presentation_content2_text1: "hero_presentation_content2_text1",
  hero_presentation_content2_title2: "hero_presentation_content2_title2",
  hero_presentation_content2_text2: "hero_presentation_content2_text2",
  hero_presentation_content2_title3: "hero_presentation_content2_title3",
  hero_presentation_content2_text3: "hero_presentation_content2_text3",
};

const HomeFAQ = {
  home_faq_title: "home_faq_title",
  home_faq_tab1: "home_faq_tab1",
  home_faq_tab2: "home_faq_tab2",
  home_faq_tab3: "home_faq_tab3",
  home_faq_tab4: "home_faq_tab4",
  home_faq_tab1_question1: "home_faq_tab1_question1",
  home_faq_tab1_question2: "home_faq_tab1_question2",
  home_faq_tab1_question3: "home_faq_tab1_question3",
  home_faq_tab1_question4: "home_faq_tab1_question4",
  home_faq_tab1_question5: "home_faq_tab1_question5",
};

const Blog = {
  blog_title: "blog_title",
  blog_text: "blog_text",
  blog_card_delivery: "blog_card_delivery",
  blog_card_coupon: "blog_card_coupon",
  blog_card_discount: "blog_card_discount",
};

export const Header = {
  header_search: "header_search",
  header_btn: "header_btn",
};


const HomePage = {
  ...HeroSection,
  ...HomeFAQ,
  ...Blog,
};

export default HomePage;
